import { today } from '@/core/helpers/date.helper';
import { StoreState } from '@/core/models/store.interface';
import { Dayjs } from 'dayjs';
import { Module } from 'vuex';
import powerBiService from './power-bi.service';

export interface PowerBiState {
   access_token?: string;
   expires_at?: Dayjs;
}

const PowerBiStore: Module<PowerBiState, StoreState> = {
   namespaced: true,
   state: {
      access_token: undefined,
      expires_at: undefined,
   },

   getters: {},

   mutations: {
      setAccessToken(state, access_token?: string) {
         state.access_token = access_token;
      },
      setExpiresAt(state, expires_in?: number) {
         state.expires_at = today.add((expires_in || 0) - 60, 'second');
      },
   },

   actions: {
      async getAccessToken({ commit, state }) {
         if (state.expires_at && today.valueOf() < state.expires_at?.valueOf()) return;
         commit('setAccessToken', undefined);
         const ACCESS_TOKEN = await powerBiService.getAccessToken();
         if (!ACCESS_TOKEN) return;
         commit('setExpiresAt', ACCESS_TOKEN.expires_in);
         commit('setAccessToken', ACCESS_TOKEN.access_token);
      },
   },
};

export default PowerBiStore;
